import Axios from '@/api/http'
/**
 * 保存报表
 * */
export function addreportmanagement (date) {
	return Axios({
		method: 'post',
		url: '/api/addreportmanagement',
		data: date
	})
}

/**
 * 根据id获取报表
 * */
export function getreportmanagementbyid (date) {
	return Axios({
		method: 'post',
		url: '/api/getreportmanagementbyid',
		data: date
	})
}

/**
 * 根据id删除报表
 * */
export function deletereportmanagement (date) {
	return Axios({
		method: 'post',
		url: '/api/deletereportmanagement',
		data: date
	})
}

/**
 * 修改报表
 * */
export function updatereportmanagement (date) {
	return Axios({
		method: 'post',
		url: '/api/updatereportmanagement',
		data: date
	})
}

/**
 * 批量导出报表生成压缩包
 * */
export function batchexportreportmanagementzip (date) {
	return Axios({
		method: 'post',
		url: '/api/batchexportreportmanagementzip',
		data: date
	})
}

/**
 * 删除生成报表压缩文件记录
 * */
export function deletereportmanagementzipbyid (date) {
	return Axios({
		method: 'post',
		url: '/api/deletereportmanagementzipbyid',
		data: date
	})
}

/**
 * 获取生成报表压缩文件记录
 * */
export function getreportmanagementziplist (date) {
	return Axios({
		method: 'post',
		url: '/api/getreportmanagementziplist',
		data: date
	})
}